import { render, staticRenderFns } from "./TicketMainSectionRightColumn.vue?vue&type=template&id=1efa685e&scoped=true&"
import script from "./TicketMainSectionRightColumn.vue?vue&type=script&lang=js&"
export * from "./TicketMainSectionRightColumn.vue?vue&type=script&lang=js&"
import style0 from "./TicketMainSectionRightColumn.vue?vue&type=style&index=0&id=1efa685e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa685e",
  null
  
)

export default component.exports